import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalT2 = () => {

return(
<div>
    
<Typography variant="h6" >

rs1800795 is a SNP in the promoter of the interleukin-6 IL6 gene, affecting the levels made of this important cytokine
Studies on rs1800795 now include potential associations with heart disease, Kaposi's sarcoma, type-2 diabetes, stroke, obesity, Hodgkin's lymphoma, sudden infant death syndrome, 
cancer (including breast cancer, gastric cancer, prostate cancer), hypertension, periodontitis, and complications arising after organ transplantations or grafts.<br /><br />

The rs1800795(G) allele was significantly associated with type-2 diabetes.

<br /><br /> 

Sources:
SNPedia  <br /><br />

 
</Typography>

</div>
)
}